/**
 * `core/barba/utils/barbaScrollManager.js`
 * - 遷移毎のスクロール位置を管理
 *
 * 使用方法:
 * - import {barbaScrollManager} from "./core/barba/utils/barbaScrollManager.js";
 *
 * 遷移毎にID（auto increment）を付与し、ブラウザのstorageにscroll.x, scroll.yを保管
 */


const SCROLL_STORAGE_KEY = "barbaScrollHistory";
const ID_STORAGE_KEY = "barbaScrollId";


/**
 * スクロール位置の保存・取得を管理
 */
export const barbaScrollManager = {
  /**
   * `現在のページのスクロール位置` を `現在のID` に紐付けて保存
   */
  save() {
    // `barbaScrollId` を取得（なければ `1` にする）
    const currentId = parseInt(sessionStorage.getItem(ID_STORAGE_KEY)) || 1;

    // 現在のスクロール位置を保存
    const scrollHistory = JSON.parse(sessionStorage.getItem(SCROLL_STORAGE_KEY)) || {};
    scrollHistory[currentId] = {
      x: window.scrollX,
      y: window.scrollY
    };

    sessionStorage.setItem(SCROLL_STORAGE_KEY, JSON.stringify(scrollHistory));
    sessionStorage.setItem(ID_STORAGE_KEY, currentId + 1); // 次の遷移のためにIDをインクリメント
  },

  /**
   * `back` or `forward` の場合、適切なスクロール位置を返す
   * @param {string} direction - "back" または "forward"
   * @returns {object} {x, y} or {x: 0, y: 0}（デフォルト）
   */
  get(direction) {
    let currentId = parseInt(sessionStorage.getItem(ID_STORAGE_KEY)) || 1;
    const scrollHistory = JSON.parse(sessionStorage.getItem(SCROLL_STORAGE_KEY)) || {};

    if (direction === "back") {
      currentId--;
    } else if (direction === "forward") {
      currentId++;
    }

    const targetId = currentId;
    if (scrollHistory[targetId]) {
      return scrollHistory[targetId] || {x: 0, y: 0};
    }

    return {x: 0, y: 0}; // デフォルトは `0`
  },

  update(direction) {
    let currentId = parseInt(sessionStorage.getItem(ID_STORAGE_KEY)) || 1;
    if (direction === "back") {
      currentId--;
    } else if (direction === "forward") {
      currentId++;
    }
    sessionStorage.setItem(ID_STORAGE_KEY, currentId);
  },

  /**
   * IDのリセット（back後に通常遷移した場合）
   */
  resetForward() {
    const currentId = parseInt(sessionStorage.getItem(ID_STORAGE_KEY)) || 1;
    const scrollHistory = JSON.parse(sessionStorage.getItem(SCROLL_STORAGE_KEY)) || {};

    console.log(`🔄 Resetting forward scroll history. Current ID=${currentId}`);

    // **現在の ID より後のデータを削除**
    Object.keys(scrollHistory).forEach(id => {
      if (parseInt(id) > currentId) {
        delete scrollHistory[id];
      }
    });

    sessionStorage.setItem(SCROLL_STORAGE_KEY, JSON.stringify(scrollHistory));
  },

  /**
   * `現在のID` をリセット（手動で初期化したいとき用）
   */
  reset() {
    sessionStorage.removeItem(SCROLL_STORAGE_KEY);
    sessionStorage.setItem(ID_STORAGE_KEY, "1");
  }
};
